// extracted by mini-css-extract-plugin
export var button = "_71-0";
export var icon = "_71-1";